import { isMobile } from "react-device-detect";
export const env_map = "/unfinished_office_night_1k.hdr";
export const assets_prefix = "/" + isMobile ? "assets_mobile" : "assets";
console.log({ assets_prefix })
export const AI_processor = "Atum A5";
export const self_disable = "self-disable";
export const secure_processor = "ECPIX Parent"; // ECPIX

export const interlock = "interlock";
export const galvanic = "CCG 30 Parent"; // Barrel_Jacks, CCG_30
export const optoIsolation = "Opto-Isolators"; // Atum_A5_Wire, TODO isolators
export const antiTamper = "anti-tamper-sensor"; // Metal Foam, Waves, Needle, DWM1001, [...camera area...]
export const offlinePower = "offline-power-source"; // Battery 1, TODO Battery management
export const router = "Router"; // Router
export const otherClusterUnits = "other-cluster-units";
export const memory = "Memory"; // TODO DDR4
export const io = "Ethernet Cable 1"; // W5500, Ethernet Cable, Ethernet_Port  (optional: W5500_Wire)
export const powerSupply = "power-supply"; // Power_Cord, Power_Plug (optional: Wires TODO?)

// clock?
